import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PrimengModule } from '../global/primeng.module';
import { SharedModule } from '../shared/shared.module';
import { InvestorModule } from '../investor/investor.module';

import { PropertyComponent } from './property.component';
import { PropertySearchService } from './property-search/property-search.service';
import { FavoritePropertiesService } from './favorite-properties.service';


import { DataViewModule } from 'primeng/components/dataview/dataview';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBed,
  faBath,
  faHome
} from '@fortawesome/free-solid-svg-icons';

import { PropertySearchComponent } from './property-search/property-search.component';
import { PropertySearchFormComponent } from './property-search/property-search-form/property-search-form.component';
import { PropertySearchResultsComponent } from './property-search/property-search-results/property-search-results.component';
import { DropdownPropertyStatusComponent } from './dropdown-status/dropdown-status.component';
import { SearchReoComponent } from './templates/search-reo/search-reo.component';
import { SearchDefaultComponent } from './templates/search-default/search-default.component';
import { SearchShortsaleComponent } from './templates/search-shortsale/search-shortsale.component';
import { SearchForclosureComponent } from './templates/search-forclosure/search-forclosure.component';
import { SearchAuctionComponent } from './templates/search-auction/search-auction.component';
import { HeaderExtendedInformationComponent } from './property-header/header-extended-information/header-extended-information.component';
import { AddonAuctionComponent } from './templates/addon-auction/addon-auction.component';
import { AddonDefaultComponent } from './templates/addon-default/addon-default.component';
import { AddonForclosureComponent } from './templates/addon-forclosure/addon-forclosure.component';
import { AddonReoComponent } from './templates/addon-reo/addon-reo.component';
import { AddonShortsaleComponent } from './templates/addon-shortsale/addon-shortsale.component';

import { CollectiveComponentLoaderService } from './../shared/service/collective-component-loader';
import { AddonPreforclosureComponent } from './templates/addon-preforclosure/addon-preforclosure.component';
import { SearchPreforclosureComponent } from './templates/search-preforclosure/search-preforclosure.component';
import { OfferModule } from '../offer/offer.module';
import { OfferCounterComponent } from '../offer/offer-counter/offer-counter.component';
import { SearchForeclosureAuctionComponent } from './templates/search-foreclosure-auction/search-foreclosure-auction.component';

library.add(faBed);
library.add(faBath);
library.add(faHome);

@NgModule({
  declarations: [
    DropdownPropertyStatusComponent,
    PropertyComponent,
    PropertySearchComponent,
    PropertySearchFormComponent,
    PropertySearchResultsComponent,
    SearchReoComponent,
    SearchDefaultComponent,
    SearchShortsaleComponent,
    SearchForclosureComponent,
    SearchAuctionComponent,
    HeaderExtendedInformationComponent,
    AddonAuctionComponent,
    AddonDefaultComponent,
    AddonForclosureComponent,
    AddonReoComponent,
    AddonShortsaleComponent,
    AddonPreforclosureComponent,
    SearchPreforclosureComponent,
    SearchForeclosureAuctionComponent
  ],
  providers: [
    PropertySearchService, CollectiveComponentLoaderService, FavoritePropertiesService
  ],
  imports: [
    CommonModule,
    FormsModule,
    PrimengModule,
    SharedModule,
    InvestorModule,
    DataViewModule,
    FontAwesomeModule
  ],
  exports: [
    DropdownPropertyStatusComponent,
    PropertyComponent,
    PropertySearchComponent,
    PropertySearchResultsComponent,
    HeaderExtendedInformationComponent
  ],
  entryComponents: [
    SearchReoComponent,
    SearchDefaultComponent,
    SearchShortsaleComponent,
    SearchForclosureComponent,
    SearchAuctionComponent,
    SearchPreforclosureComponent,
    SearchForeclosureAuctionComponent,
    AddonAuctionComponent,
    AddonDefaultComponent,
    AddonForclosureComponent,
    AddonReoComponent,
    AddonShortsaleComponent,
    AddonPreforclosureComponent
  ]
})
export class PropertyModule {
  constructor(private readonly _headerComponentService: CollectiveComponentLoaderService
    , private favoritePropertiesService: FavoritePropertiesService) {
    _headerComponentService.register('reo', [SearchReoComponent, AddonReoComponent]);
    _headerComponentService.register('other', [SearchDefaultComponent, AddonDefaultComponent]);
    _headerComponentService.register('shortsale', [SearchShortsaleComponent, AddonShortsaleComponent]);
    _headerComponentService.register('auc', [SearchAuctionComponent, AddonAuctionComponent]);
    _headerComponentService.register('fcbk', [SearchForclosureComponent, AddonForclosureComponent]);
    _headerComponentService.register('pre-fcl', [SearchPreforclosureComponent, AddonPreforclosureComponent]);
    _headerComponentService.register('auc-fcl', [SearchForeclosureAuctionComponent, AddonDefaultComponent]);
  }
}
